import React  from "react";
import {
    GoogleMap, withGoogleMap,
    DirectionsRenderer,
    KmlLayer
}                             from "react-google-maps";
import { getGoogleMap, getBounds, getLatLng }
                              from './../../classes/HandleGeo';
import PlaceMarker            from './containers/PlaceMarkerContainer';
import UserMarker             from './containers/UserMarkerContainer';

import './../../css/PlaceMap.css';

let mapObject = false;
let fitBounds = false;

//---------------------------------------------------------------------------------------------------------------

const onDefaultViewportChanged = () =>
{
    fitBounds = true;
};

//---------------------------------------------------------------------------------------------------------------

const renderMarkers = (markers, user, listView, showTrails) =>
{
    let center     = null;
    let bounds     = getBounds();

    let mapMarkers = markers.map(place =>
    {
        if (true === showTrails && listView && 'trail' === place.type && place.onList)
        {
            return (
                <KmlLayer
                    key={ place.id }
                    url={ place.kmlFile }
                    options={ { preserveViewport: (true) } }
                />)
        }
        else
        {
            if (null === center)
            {
                center = { lat: place.coords.lat, lng: place.coords.long };
            }

            let loc = getLatLng(place.coords.lat, place.coords.long);
            bounds.extend(loc);

            return (
                <PlaceMarker key={ place.id } place={ place } />
            )
        }
    });

    if (null !== user)
    {
        mapMarkers.push(<UserMarker key="user" />);
        let userLoc = getLatLng(user.latitude, user.longitude);
        bounds.extend(userLoc);
    }

    return {
        center : center,
        bounds : bounds,
        markers: mapMarkers
    }
};

//---------------------------------------------------------------------------------------------------------------

const renderOtherMarkers = (markers) =>
{
    return markers.map(place =>
    {
        return (
            <PlaceMarker key={ place.id } place={ place } />
        )
    });
};

//---------------------------------------------------------------------------------------------------------------

const hasKml = (props) =>
{
    return (typeof props.kml !== 'undefined' && null !== props.kml);
};

//---------------------------------------------------------------------------------------------------------------

const renderKml = (props) =>
{
    if (hasKml(props))
    {
        let preserve = (null !== props.zoom);
        fitBounds    = preserve;

        return (
            <KmlLayer
                url={ props.kml.url }
                options={ { preserveViewport: (preserve) } }
                onDefaultViewportChanged={ onDefaultViewportChanged.bind(this, props) }
            />)
    }
    else
    {
        return null;
    }
};

//---------------------------------------------------------------------------------------------------------------

const onMapLoad = (props, markerData, map) =>
{
    if (map)
    {
        if (false === mapObject)
        {
            props.setMapObject(map);
            mapObject = map;
        }

        if (markerData.markers.length > 0)
        {
            if (false === hasKml(props))
            {
                if (props.listView || null === props.zoom)
                {
                    fitBounds = true;
                    map.fitBounds(markerData.bounds);
                }

                map.panToBounds(markerData.bounds);
            }

            if (false === props.listView && null !== props.zoom)
            {
                getGoogleMap(map).setZoom(props.zoom);
            }
        }
    }
};

//---------------------------------------------------------------------------------------------------------------

const renderDirections = (directions) =>
{
    if (typeof directions !== 'undefined' && null !== directions) {
        return (
            <DirectionsRenderer
                directions={ directions }
                options={ { suppressMarkers : true } }
            />
        );
    }
    else
    {
        return null;
    }
};

//---------------------------------------------------------------------------------------------------------------

export const Map = withGoogleMap((props) =>
{
    let markerData = renderMarkers(props.places, props.user, props.listView, props.showTrails);

    return (
        <GoogleMap
            ref={ onMapLoad.bind(this, props, markerData) }
            defaultZoom={ props.zoom }
            defaultCenter={ markerData.center }
            preserveViewport={ true }
        >
            { markerData.markers }
            { renderOtherMarkers(props.otherPlaces) }

            { renderDirections(props.directions) }
            { renderKml(props) }
        </GoogleMap>
        );
    }
);



// WEBPACK FOOTER //
// ./src/components/Map/Map.js